module.exports = __webpack_public_path__ + "9d5d4df63a1c1ebfddae5963acd11a1c.svg";